import React, { useState, useCallback } from 'react'
import { Close } from '@material-ui/icons'
import { useStyles } from './styles'

const WHATSAPP_NUMBER = '+5567999725550'
const WHATSAPP_MESSAGE = encodeURIComponent('Olá! Encontrei um problema no sistema Congado.')
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`

const STORAGE_KEY = 'congado:dev-banner-hidden'

export const DevelopmentBanner: React.FC = () => {
  const styles = useStyles()

  const [isVisible, setIsVisible] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) !== 'true'
  })

  const handleClose = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'true')
    setIsVisible(false)
  }, [])

  if (!isVisible) return null

  return (
    <div className={styles.banner}>
      <span className={styles.text}>
        Estamos em fase de desenvolvimento. Encontrou algum problema?{' '}
        <a href={WHATSAPP_URL} target='_blank' rel='noopener noreferrer' className={styles.link}>
          Fale conosco pelo WhatsApp
        </a>
      </span>
      <button className={styles.closeButton} onClick={handleClose} aria-label='Fechar banner'>
        <Close />
      </button>
    </div>
  )
}
